// removed by extract-text-webpack-plugin
module.exports = {"filter":"src-components-Filters-Filter----Filter-module---filter---223FJ","selected":"src-components-Filters-Filter----Filter-module---selected---1NN2i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Filters/Filter/Filter.module.scss
// module id = 475
// module chunks = 128454401290669 146499011236745